import { useMemo } from "react";
import { useUser } from "src/context";
import {
  createAddressDomain,
  createApplicationDomain,
  createAssetsDomain,
  createBorrowerDomain,
  createDealerDomain,
  createDemographicsDomain,
  createDocumentsDomain,
  createEmploymentDomain,
  createExpenseDomain,
  createHomeDomain,
  createIncomeDomain,
  createLandDomain,
} from "./domains";

export function useWebClientApi() {
  const { userData } = useUser();

  const ids = useMemo(
    () => ({
      dealerId: userData?.dealer_id ?? "",
      applicationId: userData?.application_id,
      borrowerId: userData?.borrower_id,
    }),
    [userData?.dealer_id, userData?.application_id, userData?.borrower_id],
  );

  return useMemo(
    () => ({
      ...createApplicationDomain(ids),
      ...createBorrowerDomain(ids),
      ...createAddressDomain(ids),
      ...createEmploymentDomain(ids),
      ...createIncomeDomain(ids),
      ...createExpenseDomain(ids),
      ...createAssetsDomain(ids),
      ...createHomeDomain(ids),
      ...createLandDomain(ids),
      ...createDemographicsDomain(ids),
      ...createDealerDomain(ids.dealerId),
      ...createDocumentsDomain(),
    }),
    [ids],
  );
}
